import { useMediaQuery } from "@mui/material";
import bg from "../assets/images/bg.png";
import Logo from "../components/Logo";

function Frontpage() {
  const isMobile = useMediaQuery("(max-width: 720px)");
  return (
    <div className="frontpage">
      <div className="content-container">
        <div style={{ opacity: 0.8 }}>
          <Logo color="#c09c72" size="40px" />
        </div>
        <h1>KALYANAM</h1>
        <div style={{ opacity: 0.8 }}>
          <h2>
            Every detail. Every vendor. {isMobile && <br />}
            All in one place.
          </h2>
        </div>
      </div>
      <img className="bg" src={bg} alt="" />
    </div>
  );
}

export default Frontpage;
